import { FnaNeedsAnalysis } from "./FnaNeedsAnalysis";
import type { FormData, ChooseProduct } from "@ifa/utils";

interface FnaNeedsAnalysisPlaceholderProps {
  financialAnalysis?: FormData[];
  chooseProducts?: ChooseProduct[];
  sourceOrderId?: number;
  isZuuFinancialStepMode?: boolean;
}

export function FnaNeedsAnalysisPlaceholder({
  financialAnalysis,
  chooseProducts,
  sourceOrderId,
  isZuuFinancialStepMode = false,
}: FnaNeedsAnalysisPlaceholderProps) {
  return (
    <FnaNeedsAnalysis
      financialAnalysis={financialAnalysis}
      chooseProducts={chooseProducts}
      sourceOrderId={sourceOrderId}
      isZuuFinancialStepMode={isZuuFinancialStepMode}
    />
  );
}
